import { React } from "react";
import { Button, Form, Input } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm, RightDrawerContainer } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DisabledStyles } from "../../pageStyled";

const { TextArea } = Input;

const ApprovalRequestChanges = (props) => {
  return (
    <RightDrawerSidebar
      title="Request Changes"
      subtitle=""
      visible={props.visible}
      onClose={props.onCloseGrade}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <HaberForm>
            <Form
              name="basic"
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
            >
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Request Changes</h5>
                  <p>A unique auto-generated code to identify order</p>
                </div>
                <Form.Item name="Request Changes" rules={[{ required: true }]}>
                  <DisabledStyles>
                    <Input
                      defaultValue="ITC21082021"
                      disabled
                      className="requestChangeValue"
                    />
                  </DisabledStyles>
                </Form.Item>
              </div>

              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Required Changes</h5>
                  <p>Please specify required changes in this order</p>
                </div>
                <Form.Item
                  name="Required Changes"
                  rules={[{ required: true }]}
                  className=""
                >
                  <TextArea
                    maxLength={100}
                    style={{ height: 90 }}
                    placeholder="Mention the changes here"
                  />
                </Form.Item>
              </div>
              <div className="buttonFlex fixedBtm">
                <Form.Item>
                  <Button htmlType="submit" className="themeBtn">
                    <Iconmoon icon="wrong" size={16} color="#ffffff" /> Request
                    Changes
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </HaberForm>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default ApprovalRequestChanges;
